import { ApiResult, httpRequest, Urls } from './Shared';

const PROSPECT_USER_URL = `${Urls.BASE_URL}/ProspectUsers`;

export interface RegisterProspectUserDto {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    contactPreference: number;
}

export interface ProspectUserVerificationCodeDto {
    phoneNumber: string;
    verificationCode: string;
}

export interface SetPasswordDto {
    username: string;
    password: string;
    token: string;
}

export interface ForgotPasswordRequestDto {
    username: string;
}

export interface ProspectUserAuditDetails {
    lastUpdatedDateTime: string;
    lastUpdatedByUser: string;
}

export const createProspectUser = (user: RegisterProspectUserDto): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROSPECT_USER_URL}`, 'post', user);
};

export const resendRegistrationText = (phoneNumber: string): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROSPECT_USER_URL}/resend`, 'post', phoneNumber);
};

export const verifyCode = (
    codeDto: ProspectUserVerificationCodeDto
): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROSPECT_USER_URL}/verifyCode`, 'post', codeDto);
};

export const redeemPhoneCode = (
    codeDto: ProspectUserVerificationCodeDto
): Promise<ApiResult<string>> => {
    return httpRequest<string>(`${PROSPECT_USER_URL}/redeem`, 'post', codeDto);
};

export const forgotPassword = (phoneNumber: string): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROSPECT_USER_URL}/forgotPassword`, 'post', phoneNumber);
};

export const resetPassword = (passwordDto: SetPasswordDto): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROSPECT_USER_URL}/resetPassword`, 'post', passwordDto);
};

export const getProspectUserAuditDetails = (prospectUserId: string) =>
    httpRequest<ProspectUserAuditDetails>(`${PROSPECT_USER_URL}/${prospectUserId}/audit`);

export const deleteProspectUser = (): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROSPECT_USER_URL}`, 'delete');
};

export const textLink = (extension: string) =>
    httpRequest<{}>(`${PROSPECT_USER_URL}/sendText`, 'post', extension);



// WEBPACK FOOTER //
// ./src/api/ProspectUser.ts